<template>
  <div class="gatBottomPanel">

     <v-card v-if="showChanges" class="pa-2">
        <gat-grid class="elevation-0 changepanel" :columns="changeGridColumns" :items="changes()" />
    </v-card>

    <v-card class="elevation-3">
      <span class="paddingBlock"></span>
      <v-btn v-if="saveBtn" :disabled="buttonsEnabled || !valueChanged" color="success" class="ml-3" @click="$emit('saveClicked')">Save</v-btn>
      <v-btn v-if="deleteBtn" flat :disabled="buttonsEnabled || deleteDisabled"  class="ml-3 right" @click="deleteDialog=true">Delete</v-btn>
      <v-btn flat v-show="valueChanged && !showChanges"  class="right" @click="showChanges=true">show changes</v-btn>
      <v-btn flat v-show="showChanges"  class="right" @click="showChanges=false">hide changes</v-btn>
      <slot />
    </v-card>

   
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Delete {{itemDescription}}?</v-card-title>
        <!-- <v-card-text>Delete {{itemDescription}} ?</v-card-text> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="deleteDialog = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="deleteClicked">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import GatGrid from './GatGrid.vue';
  export default {
    name: 'GatBottomPanel',
    props: ['saveBtn','deleteBtn','buttonsEnabled','deleteDisabled','orgValue','newValue','itemDescription'],
    components: {GatGrid},
    data: function() {
      return	{
        deleteDialog : false,
        showChanges : false,
        changeGridColumns : [{"header":"Property","field":"propertyName",hideOnPhone:false},
                             {"header":"Old value","field":"oldValue",hideOnPhone:false},
                             {"header":"New value","field":"newValue",hideOnPhone:false}],

      }
    },

    computed:{
      valueChanged(){
        let v1 = JSON.stringify(this.orgValue);
        let v2 = JSON.stringify(this.newValue);
        return v1!=v2;
      },

    },

    methods:{
      changes(){
        let result = [];
        let orgObject = this.orgValue;
        let newObject = this.newValue;
        //finner det nye og endrede properties
        for (var prop in newObject) {
          let value1 = JSON.stringify(newObject[prop]);
          let value2 = JSON.stringify(orgObject[prop]);
          if(value1 != value2){
            result.push({propertyName:prop,oldValue:value2,newValue:value1});
          }
        }
        //finner slettede properties
        for (var orgProp in orgObject) {
          if(!newObject.hasOwnProperty(orgProp)){
              result.push({propertyName:orgProp,oldValue:JSON.stringify(orgObject[orgProp]),newValue:null});
          }
        }

        return result;
      },

      deleteClicked(){
        this.$emit('deleteClicked');
        this.deleteDialog = false;
      },
    },
  }
</script>

<style scoped>
  .gatBottomPanel{
    position:fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 3;
  }
  .paddingBlock{
    padding-right: var(--gatDrawerWitdth);
  }

  .changepanel{
    max-height: 500px;
  }
</style>
